import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LineChartComponent } from './components/line-chart.component';
import { CombinationChartComponent } from './components/combination-chart.component';

@NgModule({
  declarations: [LineChartComponent, CombinationChartComponent],
  imports: [CommonModule],
  exports: [LineChartComponent, CombinationChartComponent],
})
export class SharedChartsModule {}
